import React, { useState } from "react";
import config from "../config";

function extractCity(address) {
  if (!address) return "";
  const parts = address.split(",");
  if (parts.length < 2) return address.trim();
  return parts[parts.length - 1].trim().replace(/^\d{5}\s*/, "");
}

function formatDate(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

function Card({ title, text, views, rating, address, image, createdAt }) {
  const [imgError, setImgError] = useState(false);
  const imagePath = config.BaseUrl + image;

  const city = extractCity(address);
  const ratingDisplay = rating != null ? Math.round(rating * 10) / 10 : null;

  return (
    <>
      <div className="review-img">
        {image && !imgError ? (
          <img src={imagePath} alt={title} onError={() => setImgError(true)} />
        ) : (
          <div className="review-img-placeholder">🌯</div>
        )}
        {ratingDisplay !== null && (
          <div className="review-rating-badge">
            <span className="star">★</span>
            {ratingDisplay}
          </div>
        )}
      </div>
      <div className="review-content">
        <div className="review-meta-top">
          {city && <span className="review-location">{city}</span>}
          {views > 0 && (
            <span className="review-num">
              <i className="fa-regular fa-eye" /> {views}
            </span>
          )}
        </div>
        <div className="review-name">{title}</div>
        {text && <p className="review-quote">{text}</p>}
        <div className="review-foot">
          <div className="review-address">{address}</div>
          {formatDate(createdAt) && (
            <span className="review-date">
              <i className="fa-regular fa-calendar" />
              {formatDate(createdAt)}
            </span>
          )}
        </div>
      </div>
    </>
  );
}

export default Card;
